import { useCallback, useMemo } from 'react'
import { Ban } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchBlockingDemands, LEGAL_STATUS_OPTS, LEGAL_STR as S, type LegalRow } from './legalFlowApi'

/**
 * A19.08 — Bloklash talablari (blocking demands, read-only). Kontent/akkauntni
 * bloklash haqidagi qonuniy talablar (kind=blocking). GET /admin/legal ustidan.
 * Backend yo'q/xato → fail-soft.
 */
export function LegalBlockingScreen() {
  const columns = useMemo<AdminColumn<LegalRow>[]>(
    () => [
      { key: 'id', header: S.id, type: 'id', width: 70 },
      { key: 'created_at', header: S.created, type: 'date', width: 150 },
      { key: 'authority', header: S.authority, type: 'text', minWidth: 180 },
      { key: 'reference', header: S.reference, type: 'text', width: 150 },
      { key: 'jurisdiction', header: S.jurisdiction, type: 'text', width: 150 },
      {
        key: 'affected_user_id',
        header: S.affected,
        type: 'text',
        width: 150,
        sortable: false,
        render: (r) => (r.affected_user_id ? (r.username ? `@${r.username}` : `#${r.affected_user_id}`) : '—'),
      },
      { key: 'status', header: S.status, type: 'enum', width: 130, options: LEGAL_STATUS_OPTS },
    ],
    [],
  )
  const fetcher = useCallback(fetchBlockingDemands, [])
  return (
    <>
      <PageHeader title={S.blockingTitle} screenId="A19.08" description={S.blockingDesc} />
      <DataTable<LegalRow>
        screenId="A19.08"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Ban size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
